/**
 * 共享时长选项常量，用于全局统一管理共享持续时间选项
 * 修改此文件将影响所有使用这些常量的组件
 */

/**
 * 共享时长选项列表
 * @type {Array<{label: string, value: number}>}
 */
export const SHARE_DURATION_OPTIONS = [
  { label: '7天', value: 7 },
  { label: '30天', value: 30 },
  { label: '90天', value: 90 },
  { label: '永久共享', value: 999 }
];

/**
 * 默认共享时长（天）
 * @type {number}
 */
export const DEFAULT_SHARE_DURATION = 7;

/**
 * 根据值获取共享时长的标签
 * @param {number} value - 共享时长值
 * @returns {string} - 对应的标签文本
 */
export const getShareDurationLabel = (value) => {
  const option = SHARE_DURATION_OPTIONS.find(item => item.value === value);
  return option ? option.label : '未知';
};